<!-- 用于刷新路由 license by http://eleadmin.com -->
<template>
  <div></div>
</template>

<script>
  export default {
    name: 'EleRedirect',
    created() {
      const current = this.$route;
      const path = current.path.substring('/redirect'.length);
      this.$store.dispatch('theme/setKeepAliveExclude', []).then(() => {
        this.$router.replace({
          path: path,
          query: current.query
        });
      });
    }
  };
</script>
